import type {PlantHierarchyNode} from '@hproduce/suite-core'

export const getHierarchyNodeById = (
  nodes: PlantHierarchyNode[],
  hierarchyId: string
): PlantHierarchyNode | null => {
  for (const rootNode of nodes) {
    const result = searchNode(rootNode, hierarchyId)
    if (result) return result
  }
  return null
}

const searchNode = (node: PlantHierarchyNode, hierarchyId: string): PlantHierarchyNode | null => {
  if (node.hierarchyId === hierarchyId) {
    return node
  }

  if (node.children) {
    for (const child of node.children) {
      const result = searchNode(child, hierarchyId)
      if (result) return result
    }
  }

  return null
}

export const getHierarchyNodeNameByIdOrThrow = (
  nodes: PlantHierarchyNode[],
  hierarchyId: string
): string => {
  const hierarchyNode = getHierarchyNodeById(nodes, hierarchyId)
  if (hierarchyNode === null) {
    throw new Error('BUG: Provided hierarchyId not found in plant hierarchy')
  }
  return hierarchyNode.name
}
